export const REQUEST_SENT = 'REQUEST_SENT';
export const REQUEST_OVER = 'REQUEST_SUCCESS';
export const LOAD_SIGNWORKFLOWS_SUCCESS = 'LOAD_SIGNWORKFLOWS_SUCCESS';
export const LOAD_ERROR = 'LOAD_ERROR';
export const GET_TEMPLATE_SUCCESS = 'GET_TEMPLATE_SUCCESS';
export const GET_TEMPLATE_FAILED = 'GET_TEMPLATE_FAILED';
export const UPDATE_CREATION_STATE = 'UPDATE_CREATION_STATE';



// WEBPACK FOOTER //
// ./src/store/modules/signWorkflow/types.js